import React from "react";
import cn from "classnames";
import styles from "./style.scss";

export const SkeletonBar: React.FC = () => {
  return (
    <div className={styles.skeleton}>
      <span className={cn(styles.text, styles.top)} />
      <span className={cn(styles.text, styles.bottom)} />
    </div>
  );
};
